export const heightWidthOfPreviewImage = 60;
export const marginPreviewImage = 10;

export const ZoomboxIconsCSS = {
  COLOR: '#fff',
  STROKE_WIDTH: 2
};

export const MAX_ZOOM = 3; // 3 * 100%
export const MIN_ZOOM = 0.2; // 0.2 * 100%
export const ZOOM_STEP = 0.1; // 0.1 * 100%
export const DEFAULT_ZOOM = 1; // 1 * 100%
export const ENABLE_DRAG_AT_ZOOM = 1.5;
